// Module
var code = "<p>[# connection-error] We couldn&#39;t establish websocket connection to a full node.</p> <p>Possible reasons: TODO</p> <ul> <li>reason #1</li> <li>reason #2</li> </ul> ";
// Exports
export default code;